export const logTablecoloumn = [
  { title: "Date", date: true },
  { title: "User" },
  { title: "Note" },
];

export const firstTablecoloumn = [
  { title: "Reference" },
  { title: "Docket" },
  { title: "Court" },
  { title: "Fee" },
  { title: "Amount" },
  { title: "Paid" },
  { title: "Write Off" },
  { title: "Balance" },
  { title: "On Hand" },
  { title: "Amount to Deallocate" },
];
export const setTableData = (dataa) => {
  const arr = [];
  dataa.map((val, i) => {
    let match = val?.sLastFirst?.match(/\((.*?)\)/);
    let name = val?.sLastFirst?.match(/([^()])+|(\(.*\))/g);
    arr.push({
      Select: false,
      Active: val?.active,
      "Date Entered": val?.dDoe,
      "Due Date": val?.dueDate,
      "Days Till Due": val?.daysTillDue,
      "Assigned To": val?.assignedToName,
      Category: val?.categoryName,
      Status: val?.statusName,
      Title: val?.title,
      Note: val?.note,
      "Associated Person": val?.sLastFirst,
      "Entered By": val?.enteredBy,
      "Date Completed": val?.dateCompleted,
      ID: val?.taskId,
      taskId: val?.taskId,
      assignedToId: val?.assignedToId,
      categoryId: val?.categoryId,
      statusId: val?.statusId,
      offenderNumber: match ? match[1] : "",
      name: name ? name[0] : "",
      body: val
    });
  });

  return arr;
};